/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_CurrencyInputs */

const cs_form_currency = /** @type {(inputs: Form_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měna`)
};

const en_form_currency = /** @type {(inputs: Form_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

/**
* | output |
* | --- |
* | "Currency" |
*
* @param {Form_CurrencyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_currency = /** @type {((inputs?: Form_CurrencyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_CurrencyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_currency(inputs)
	return cs_form_currency(inputs)
});